$(".popup__close, .popup").on("click", function(event) {
	const popup = $(this).closest(".popup");
	const nextElement = popup.find(".popup__close").next();
	if (
		$(event.target).is(".popup__close") ||
		!$(event.target).closest(nextElement).length
	) {
		$(".popup").fadeOut();
		if (
			!$(".full-screen-menu").is(":visible") &&
			!$(".protect-against__popup").is(":visible")
		) {
			$("body").removeClass("fix");
		}
		setTimeout(() => {
			history.replaceState(
				null,
				document.title,
				location.pathname + location.search
			);
		}, 600);
		$("select.estimate-form-select").minimalect();
	}
});

$(document).on(
	"click",
	".thank-you-message__button, .error-message__button",
	function() {
		$(".popup").fadeOut();
		if (
			!$(".full-screen-menu").is(":visible") &&
			!$(".protect-against__popup").is(":visible")
		) {
			$("body").removeClass("fix");
		}
		setTimeout(() => {
			history.replaceState(
				null,
				document.title,
				location.pathname + location.search
			);
		}, 600);
		$("select.estimate-form-select").minimalect();
	}
);

$(document).on("nfFormReady", function() {
	$(document).on("click", ".estimate-form-submit", function() {
		if (
			$(".estimate-form .nf-after-form-content").find(".nf-error-msg").length !=
			0
		) {
			$("#errorPopup").fadeIn();
			$("body").addClass("fix");
		}
	});
	$(document).on("click", ".contact-us-form-submit", function() {
		if (
			$(".contact-us-form .nf-after-form-content").find(".nf-error-msg")
				.length != 0
		) {
			$("#errorPopup").fadeIn();
			$("body").addClass("fix");
		}
	});

	$(document).on("click", ".join-us-form-submit ", function() {
		if (
			$(".join-us-form .nf-after-form-content").find(".nf-error-msg").length !=
			0
		) {
			$("#errorPopup").fadeIn();
			$("body").addClass("fix");
		}
	});

	$(document).on("click", ".pool-pest-form-submit ", function() {
		if (
			$(".pool-pest-us-form .nf-after-form-content").find(".nf-error-msg")
				.length != 0
		) {
			$("#errorPopup").fadeIn();
			$("body").addClass("fix");
		}
	});
});

$(document).on("nfFormSubmitResponse", function(event, response) {
	if (typeof response.response.data.actions.success_message === "undefined") {
		return;
	}

	const successPopup = $("#successPopup");
	const estimateFormModal = $(".estimate-form.modal");
	const forms = $(".nf-form-cont");
	let hash = "#thank-you";

	const formId = response.response.data.form_id;
	const currentForm = forms.filter(`#nf-form-${formId}-cont`);

	const classList = Array.from(currentForm[0].classList);
	const matchingClass = classList.find(item => item.startsWith("js-form_"));

	if (matchingClass) {
		hash += `-${matchingClass.split("_")[1]}`;
	}

	history.replaceState(
		null,
		document.title,
		location.pathname + location.search + hash
	);

	event.preventDefault();

	if (response.response.data.actions.success_message) {
		successPopup
			.find(".js-success-message")
			.html(response.response.data.actions.success_message);
	}

	estimateFormModal.fadeOut(() => {
		successPopup.fadeIn();
	});

	$("body").addClass("fix");
});



// WEBPACK FOOTER //
// ./scripts/modules/ninja-forms-events.js